const mixin = {
  data() {
    return {
      //参数列表
      paramOptions: [],
      //模板属性
      goodsOptions: [],
      //dynamicList里的第一层坐标
      chooseIndex: undefined,
      //dynamicList中type==row的数组，里面children的坐标
      chooseSubIndex: undefined,
      drag: false,
      id: 3,
      //dynamicList：main框架里面遍历的数组
      //!label的含义
      //1.main:整个main的div
      //2.div：文本
      //3.image：图片
      //4.video 视频
      //5.row：栅格（其中col代表占24栅格中的几栅格）
      dynamicList: [],
      //templateDiv：mian里面的数据样式
      templateDiv: {},
      //editForm：正在修改的数据样式
      editForm: {},
      templateId: undefined
    };
  },
  methods: {
    //设置main的样式
    setTemplateDiv() {
      this.editForm = this.templateDiv;
      if (this.chooseSubIndex !== undefined) {
        this.dynamicList[this.chooseIndex].htmlStyleList[
          this.chooseSubIndex
        ].isChoose = false;
      } else if (this.chooseIndex !== undefined) {
        this.dynamicList[this.chooseIndex].isChoose = false;
      }
      this.chooseIndex = undefined;
      this.chooseSubIndex = undefined;
    },
    // edit-panel里面的方法----------------------------------------------------------------------------
    //改变元素类型
    //例如：图片改文本，文本改视频这类
    changeType() {
      if (this.chooseSubIndex !== undefined) {
        this.dynamicList[this.chooseIndex].htmlStyleList[
          this.chooseSubIndex
        ].label = this.editForm.label;
        if (this.editForm.label == "image" || this.editForm.label == "video") {
          this.dynamicList[this.chooseIndex].htmlStyleList[
            this.chooseSubIndex
          ].height = 300;
          this.editForm.height = 300;
        } else {
          this.dynamicList[this.chooseIndex].htmlStyleList[
            this.chooseSubIndex
          ].height = 21;
          this.editForm.height = 21;
        }
        this.dynamicList[this.chooseIndex].htmlStyleList[
          this.chooseSubIndex
        ].style = this.getStyle(this.editForm);
      } else {
        this.dynamicList[this.chooseIndex].label = this.editForm.label;
        if (this.editForm.label == "image" || this.editForm.label == "video") {
          this.dynamicList[this.chooseIndex].height = 300;
          this.editForm.height = 300;
        } else {
          this.dynamicList[this.chooseIndex].height = 21;
          this.editForm.height = 21;
          if (this.editForm.label == "list") {
            let obj = {
              id: 1,
              height: 21,
              isChoose: false,
              width: 50,
              title: this.paramOptions[0].name,
              attribute: this.paramOptions[0].remark,
              isChoose: false,
              label: "div",
              style: "",
              padding: 0,
              marginTop: 0,
              rate: 3,
              className: "",
              css: undefined,
              background: "rgb(14, 156, 238)",
              marginLeft: 10,
              fontSize: 13,
              color: "#fff",
              fontWeight: undefined,
              custom: undefined,
              textAlign: "center",
              borderRadius: 6
            };
            obj.style = this.getStyle(obj);
            this.dynamicList[this.chooseIndex].htmlStyleList = [obj];
          } else {
            this.dynamicList[this.chooseIndex].htmlStyleList = undefined;
          }
        }
        this.dynamicList[this.chooseIndex].style = this.getStyle(this.editForm);
      }
    },
    //修改dynamicList里width,height,fong-size等css值，并且更新style样式
    changeStyle(param) {
      if (this.templateDiv.objectType == "轮播图") {
        this.templateDiv = JSON.parse(JSON.stringify(this.editForm));
        this.templateDiv.style = this.getStyle(this.editForm);
        this.editForm.style = this.getStyle(this.editForm);
      } else {
        if (this.editForm.label == "main") {
          this.templateDiv = JSON.parse(JSON.stringify(this.editForm));
          this.templateDiv.style = this.getStyle(this.editForm);
        } else if (this.chooseSubIndex !== undefined) {
          this.dynamicList[this.chooseIndex].htmlStyleList[this.chooseSubIndex][
            param
          ] = this.editForm[param];
          this.dynamicList[this.chooseIndex].htmlStyleList[
            this.chooseSubIndex
          ].style = this.getStyle(this.editForm);
        } else {
          this.dynamicList[this.chooseIndex][param] = this.editForm[param];
          this.dynamicList[this.chooseIndex].style = this.getStyle(
            this.editForm
          );
        }
      }
    },
    //修改dynamicList里字段的值，无关样式
    //例如：title
    changeParam(param) {
      if (this.templateDiv.objectType == "轮播图") {
      } else {
        if (
          this.chooseSubIndex !== undefined &&
          this.chooseIndex !== undefined
        ) {
          this.dynamicList[this.chooseIndex].htmlStyleList[this.chooseSubIndex][
            param
          ] = this.editForm[param];
        } else if (
          this.chooseIndex != undefined &&
          this.chooseSubIndex == undefined
        ) {
          this.dynamicList[this.chooseIndex][param] = this.editForm[param];
        } else {
          this.templateDiv[param] = this.editForm[param];
        }
      }
    },
    //更改绑定字段
    changeAttribute(attribute, title) {
      if (this.chooseSubIndex !== undefined) {
        this.dynamicList[this.chooseIndex].htmlStyleList[
          this.chooseSubIndex
        ].title = title;
        this.dynamicList[this.chooseIndex].htmlStyleList[
          this.chooseSubIndex
        ].custom = title;
        this.dynamicList[this.chooseIndex].htmlStyleList[
          this.chooseSubIndex
        ].attribute = attribute;
      } else {
        this.dynamicList[this.chooseIndex].title = title;
        this.dynamicList[this.chooseIndex].custom = title;
        this.dynamicList[this.chooseIndex].attribute = attribute;
      }
    },
    //拼接style

    getStyle(obj, bol) {
      let width = 0;
      if (bol) {
        //当需要保存提交时，重新计算main的style，width不加2
        width = obj.width;
      } else {
        //设置main的style时，宽度默认加2
        width = obj.label == "main" ? obj.width + 2 : obj.width;
      }
      return `box-sizing: border-box;${
        obj.width ? "width:" + width + "px" : ""
      };${obj.height ? "height:" + obj.height + "px" : ""};${
        obj.padding ? "padding:" + obj.padding + "px" : ""
      };${obj.marginTop ? "margin-top:" + obj.marginTop + "px" : ""};${
        obj.marginLeft ? "margin-left:" + obj.marginLeft + "px" : ""
      };${obj.fontSize ? "font-size:" + obj.fontSize + "px" : ""};${
        obj.color ? "color:" + obj.color : ""
      };${obj.background ? "background:" + obj.background : ""};${
        obj.fontWeight ? "font-weight:" + obj.fontWeight : ""
      };${obj.textAlign ? "text-align:" + obj.textAlign : ""};${
        obj.borderRadius ? "border-radius:" + obj.borderRadius + "px" : ""
      };${obj.css}`;
    },
    //删除元素
    deleteElement() {
      if (this.dynamicList.length == this.chooseIndex + 1) {
        this.dynamicList.splice(this.chooseIndex, 1);
        this.chooseIndex--;
        this.chooseSubIndex = undefined;
        if (this.chooseIndex >= 0) {
          this.chooseMuban(this.chooseIndex);
        } else {
          this.chooseIndex = undefined;
          this.setTemplateDiv();
        }
      } else {
        this.dynamicList.splice(this.chooseIndex, 1);
      }
    },
    //---------------------------------------------------------------------------- edit-panel里面的方法
    //添加元素
    addDiv(val, arr) {
      let maxWidth = this.templateDiv.width - this.templateDiv.padding * 2;
      let obj = {
        height: undefined,
        width: maxWidth,
        marginTop: 0,
        css: undefined,
        marginLeft: 0,
        padding: 0,
        fontSize: 13,
        color: "#303133",
        fontWeight: undefined,
        textAlign: "left",
        rate: 3,
        className: "",
        borderRadius: 0
      };
      let title = undefined;
      let attribute = undefined;
      if (this.templateDiv.objectType == "组合") {
        title = "组件1";
      } else {
        title = this.paramOptions[0].name;
        attribute = this.paramOptions[0].remark;
      }
      if (val == "row") {
        let newArr = [];
        if (arr) {
          arr.forEach(item => {
            let obj = {
              id: this.id,
              height: 21,
              //item：24栅格中占比数
              //maxWidth：最大宽度
              //20：templete-one里面el-row的默认gutter距离
              //20*arr.length-1 为gutter的个数*默认值（20）
              width: parseInt((item * maxWidth) / 24),
              title,
              attribute,
              custom: title,
              isChoose: false,
              rate: 3,
              className: "",
              label: "div",
              style: "",
              col: item * 1,
              padding: 0,
              marginTop: 0,
              css: undefined,
              marginLeft: 0,
              fontSize: 13,
              color: "#303133",
              fontWeight: undefined,
              textAlign: "left",
              borderRadius: 0
            };
            obj.style = this.getStyle(obj);
            newArr.push(obj);
            this.id++;
          });
        }
        this.dynamicList.push({
          id: this.id,
          title: this.id * 66,
          isChoose: false,
          height: undefined,
          width: maxWidth,
          padding: 0,
          marginLeft: 0,
          css: undefined,
          label: "row",
          style: "",
          htmlStyleList: newArr
        });
      } else if (val == "div") {
        let id = 0;
        let newArr = [];
        this.dynamicList.push({
          id: this.id,
          height: 21,
          width: maxWidth,
          isChoose: false,
          custom: undefined,
          label: "div",
          style: this.getStyle(obj),
          padding: 0,
          marginTop: 0,
          css: undefined,
          marginLeft: 0,
          fontSize: 13,
          color: "#303133",
          fontWeight: undefined,
          textAlign: "left",
          borderRadius: 0,
          title,
          attribute,
          rate: 3,
          className: "",
          custom: title
        });
      }
      this.id++;
    },
    //为了解决选不中栅格，添加的方法
    chooseRow() {
      this.dynamicList[this.chooseIndex].htmlStyleList[
        this.chooseSubIndex
      ].isChoose = false;
      this.chooseSubIndex = undefined;
      this.chooseMuban(this.chooseIndex);
    },
    // template-one里面的方法----------------------------------------------------------------------------
    //选择dynamicList下的元素
    //三种情况
    //1.一开始选的是栅格里的div  (有chooseIndex跟chooseSubIndex)
    //2.一开始就没有选中  (chooseIndex==undefined&&this.chooseSubIndex == undefined)
    //3.一开始选的是单独的div (chooseIndex!=undefined&&this.chooseSubIndex == undefined)
    chooseMuban(index) {
      if (this.chooseIndex !== undefined && this.chooseSubIndex !== undefined) {
        //情况1
        this.dynamicList[this.chooseIndex].htmlStyleList[
          this.chooseSubIndex
        ].isChoose = false;
        this.dynamicList[index].isChoose = true;
      } else if (
        this.chooseIndex == undefined &&
        this.chooseSubIndex == undefined
      ) {
        //情况2
        this.dynamicList[index].isChoose = true;
      } else {
        //情况3
        this.dynamicList[this.chooseIndex].isChoose = false;
        this.dynamicList[index].isChoose = true;
      }
      this.restChooseIndex(index, undefined);
      this.editForm = this.dynamicList[index];
    },
    //选择栅格栏里面的元素
    //三种情况同上
    chooseSubMuban(index, subIndex) {
      if (this.chooseIndex !== undefined && this.chooseSubIndex !== undefined) {
        //情况1
        this.dynamicList[this.chooseIndex].htmlStyleList[
          this.chooseSubIndex
        ].isChoose = false;
        this.dynamicList[index].htmlStyleList[subIndex].isChoose = true;
      } else if (
        this.chooseIndex == undefined &&
        this.chooseSubIndex == undefined
      ) {
        //情况2
        this.dynamicList[index].htmlStyleList[subIndex].isChoose = true;
      } else {
        //情况3
        this.dynamicList[this.chooseIndex].isChoose = false;
        this.dynamicList[index].htmlStyleList[subIndex].isChoose = true;
      }
      this.restChooseIndex(index, subIndex);
      this.editForm = this.dynamicList[index].htmlStyleList[subIndex];
    },
    //更新选中的index
    restChooseIndex(val, val2) {
      this.chooseIndex = val;
      this.chooseSubIndex = val2;
    },
    //---------------------------------------------------------------------------- template-one里面的方法
    //拖拽记录起始坐标
    start(evt) {
      this.drag = true;
      this.dynamicList[evt.oldIndex].isChoose = true;
    },
    //结束拖拽记录坐标
    end(evt) {
      this.drag = true;
      this.dynamicList[evt.newIndex].isChoose = false;
    },

    //更改点击事件
    changeMethod(param, val, url) {
      if (this.chooseSubIndex !== undefined && this.chooseIndex !== undefined) {
        this.dynamicList[this.chooseIndex].htmlStyleList[this.chooseSubIndex][
          param
        ] = val;
        this.dynamicList[this.chooseIndex].htmlStyleList[
          this.chooseSubIndex
        ].url = url;
      } else if (
        this.chooseSubIndex == undefined &&
        this.chooseIndex !== undefined
      ) {
        this.dynamicList[this.chooseIndex][param] = val;
        this.dynamicList[this.chooseIndex].url = url;
      } else {
        this.editForm[param] = val;
        this.templateDiv[param] = val;
        this.editForm.url = url;
        this.templateDiv.url = url;
      }
    },
    changeTemplateId(val) {
      this.editForm.templateId = val;
      this.templateDiv.templateId = val;
    },
    changeRelation(val) {
      this.api.template.getTemplate(val).then(res => {
        if (this.chooseIndex != undefined && this.chooseSubIndex == undefined) {
          this.dynamicList[this.chooseIndex].height = undefined;
          this.dynamicList[this.chooseIndex].style = this.getStyle(
            this.dynamicList[this.chooseIndex]
          );
          this.dynamicList[this.chooseIndex].template = res.data;
        } else if (
          this.chooseIndex != undefined &&
          this.chooseSubIndex != undefined
        ) {
          this.dynamicList[this.chooseIndex].htmlStyleList[
            this.chooseSubIndex
          ].height = undefined;
          this.dynamicList[this.chooseIndex].htmlStyleList[
            this.chooseSubIndex
          ].style = this.getStyle(
            this.dynamicList[this.chooseIndex].htmlStyleList[
              this.chooseSubIndex
            ]
          );
          this.dynamicList[this.chooseIndex].htmlStyleList[
            this.chooseSubIndex
          ].template = res.data;
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
export default mixin;



// WEBPACK FOOTER //
// ./src/components/onlineTemplate/mixin.js